module.exports = __webpack_public_path__ + "img/success.bf0554da.svg";